import { useDeveloperHasPermission } from "@services/useDeveloperHasPermission";
import { useFeatureOn } from "@services/useFeatureOn";

/**
 * Returns whether the current developer can use the BrazeAI Operator™.
 */
export const useCanUseOperator = () => {
  const featureOn = useFeatureOn();

  const operatorFeatureEnabled = featureOn("sage_ai_agentic");

  const someProviderAvailable = featureOn("sage_ai_agentic_openai") || featureOn("sage_ai_agentic_gemini");

  const developerHasPermission = useDeveloperHasPermission();
  const useOperatorPermissionEnabled = featureOn("fix_granular_permission_use_operator");
  const authorized =
    !useOperatorPermissionEnabled || developerHasPermission("appGroup", { permission: "useOperator" });

  return operatorFeatureEnabled && someProviderAvailable && authorized;
};
